export default "__VITE_ASSET__fedbf299__"